var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:( _obj = { 'current-tab': _vm.tabName === _vm.currentTab }, _obj[_vm.tabName] = true, _obj ),on:{"click":function($event){_vm.link(_vm.tabName)}}},[_vm._v("\n  "+_vm._s(_vm.getMenuName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }